import React from 'react';

import { alpha, Box, Fab } from '@mui/material';

import {
  boxShadows, cardDimensions, palette, spaces
} from '../../../../assets/styles/themes/tokens';
import getMuiIcon from '../../../../utils/getMuiIcon';

const PlayIcon: React.FC<{ size?: 'small' | 'large' }> = ({
  size = 'large',
}) => {
  const sizeDependantContainerSx =
    size === 'large'
      ? {
        height: cardDimensions.long.height,
        zIndex: 0,
        ':hover': {
          borderRadius: spaces.lg,
          boxShadow: boxShadows.elevation26,
        },
      }
      : { width: '100%', zIndex: 1 };

  const sizeDepenantIconSx = size === 'large' ? {}
    : { color: palette.text.secondary, stroke: palette.text.secondary };

  return (
    <Box
      sx={{
        position: 'absolute',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        inset: 0,
        ...sizeDependantContainerSx,
      }}
    >
      <Fab
        size={size}
        color='default'
        sx={{ background: alpha(palette.common.white, 0.32) }}
      >
        <Box component={getMuiIcon('play')} sx={sizeDepenantIconSx} />
      </Fab>
    </Box>
  );
};

export default PlayIcon;
